<template>
    <transition name="toggleContentComponent">
        <article class="imageAndTextTemplate main-background" v-if="ready">
            <div class="img-container">
                <img v-show="this.properties?.image" :src="getMediaPath">
            </div>
            <div class="text-container">
                <h2>{{ properties?.title }}</h2>
                <div class="scroll-container" v-html="properties?.description"></div>
            </div>
            <ShareButton />
        </article>
    </transition>
</template>
<script>
import ShareButton from '../../ui/ShareButton.vue'

export default {
    props: ['properties', 'slug'],
    components: {
        ShareButton
    },
    data() {
        return {
            ready: false
        }
    },
    mounted() {
        this.ready = true;
    },
    methods: {
        closeComponent() {
            this.$emit("closeComponent", this.slug)
        }
    },
    computed: {
        getMediaPath() {
            return app.api.Utils.getMediaPath(this.properties?.image?.src)
        },
    }
}
</script>


<style lang="scss">
.imageAndTextTemplate {
    height: 100%;
    inset: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;

    .img-container {
        overflow: hidden;
    }
    
    img {
        object-fit: cover;
        height: 100%;
        width: 100%;
    }
}
</style>